import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(private http: HttpClient) { }

  getCustomer(customerId: string) {
    return lastValueFrom(this.http.get<any>('/api/customer/get/' + customerId));
  }

  findCustomer(criteria: { [key: string]: any } | string) {
    return lastValueFrom(this.http.post<{ List: any[], Total: number }>('/api/customer/find', typeof criteria == 'string' ? { query: criteria } : criteria));
  }

  saveCustomer(customer: any) {
    return lastValueFrom(this.http.post<any>('/api/customer/save', customer));
  }
}
